import React from 'react';

const Button = ({ text, className, link, func, type }) => {
  return (
    <a href={link} className={`px-10 py-3.5 w-full text-center rounded-md shadow-md block sm:w-auto cursor-pointer duration-300 bg-indigo-600 text-white ${className}`} onClick={func} type={type}>
      {text}
    </a>
  );
};

export default Button;